import { ReactNode } from 'react'

import PageShell from '@/components/PageShell'
import SettingsSidebar from '@/layouts/partials/SettingsSidebar'

interface SettingsLayoutPropsInterface {
  children: ReactNode
  activeItem: string
}

export const settingsActiveItemFor = (pathname: string): string => {
  if (pathname.startsWith('/settings/company-profile')) return 'company-profile'
  if (pathname.startsWith('/settings/flex-insights')) return 'flex_insights'
  if (pathname.startsWith('/settings/security')) return 'security'
  return 'users'
}

const SettingsLayout = ({
  children,
  activeItem,
}: SettingsLayoutPropsInterface) => (
  <PageShell as="section" className="relative flex flex-col">
    <SettingsSidebar activeItem={activeItem} />

    <div className="w-full pt-8">{children}</div>
  </PageShell>
)

export default SettingsLayout
